// Commercial (email / SMS) marketing consent — frontend helpers.
//
// Kept SEPARATE from cookie/advertising consent (lib/consent.js). These opt-ins are
// explicit form actions, always unchecked by default and never required to submit.
// Granting one channel never grants the other. The SMS opt-in requires a user-provided
// mobile and is bound to that number on the backend (E.164 normalized).

export const EMAIL_TEXT_VERSION = "comms-v1";
export const SMS_TEXT_VERSION = "sms-v1";

// US-compliant marketing-SMS disclosure. The trailing "See our Privacy Policy and
// Terms." is rendered as links by the CommsConsent component.
export const SMS_CONSENT_TEXT_LEAD =
  "I agree to receive recurring marketing text messages from Destino Europe at the mobile number provided. Consent is not a condition of purchase. Message frequency varies. Message and data rates may apply. Reply STOP to opt out.";
export const SMS_CONSENT_TEXT = `${SMS_CONSENT_TEXT_LEAD} See our Privacy Policy and Terms.`;

// Build the commercial_consent payload for a form submit.
// `email` / `sms` are the checkbox states; pass only the ones the form showed
// (omit a key entirely when that checkbox was not presented on the form).
export function buildCommercialConsent({ email, sms } = {}) {
  const payload = {
    text_version: EMAIL_TEXT_VERSION,
    sms_text_version: SMS_TEXT_VERSION,
    page_path: typeof window !== "undefined" ? window.location.pathname + window.location.search : undefined,
  };
  if (email !== undefined) payload.email_marketing = Boolean(email);
  if (sms !== undefined) payload.sms_marketing = Boolean(sms);
  return payload;
}
